import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_VOICE_TONE_EXPORTS_QUERY_KEY } from './useGetVoiceToneExports';

import { CreateExportDto, voiceToneService } from '@/services/VoiceTone';

export function useCreateVoiceToneExport() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (dto: CreateExportDto) => voiceToneService.createExport(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_VOICE_TONE_EXPORTS_QUERY_KEY,
      });
    },
  });

  return {
    createVoiceToneExport: mutateAsync,
    isLoading: isPending,
  };
}
